import { Controller, useForm } from 'react-hook-form'
import { Col, Container, Row } from 'react-bootstrap'
import { ScopedBlock } from '../../../../../components/ScopedBlock/ScopedBlock'
import { MissingScopeAction } from '../../../../../components/ScopedBlock/models'
import { Button } from '../../../../../components/Button/Button'
import { SelectDropdown } from '../../../../../components/SelectDropdown/SelectDropdown'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../common/integrations'
import { AdvisorEngineContactCreateDefaultValues, AdvisorEngineContactCreateFormValues } from './models'
import { useAdvisorEngineContactCreate } from './hooks'

export const AdvisorEngineContactCreateSettings = () => {
  const { savedContactCreate, officeOptions, securityGroupOptions, isFetching, isSaving, save } = useAdvisorEngineContactCreate()
  const integrationDisplayName = getIntegrationDisplayName(IntegrationServiceId.ADVISOR_ENGINE)

  const form = useForm<AdvisorEngineContactCreateFormValues>({
    defaultValues: AdvisorEngineContactCreateDefaultValues,
    values: savedContactCreate ? { contactCreate: savedContactCreate } : undefined,
  })

  const onSubmit = async (data: AdvisorEngineContactCreateFormValues) => {
    await save(data)
  }

  const handleReset = () => {
    form.reset()
  }

  if (isFetching) {
    return (
      <Container>
        <div className='skeleton mb-2' style={{ width: '100%', height: '70px' }} />
        <div className='skeleton mb-3' style={{ width: '100%', height: '70px' }} />
      </Container>
    )
  }

  return (
    <Container>
      <h6>Contact Create</h6>
      <div>Choose where Zocks creates new contacts in {integrationDisplayName}.</div>
      <Row className='mb-1 mt-3'>
        <Col className='d-flex align-items-center'>
          <div>Office</div>
        </Col>
        <Col>
          <ScopedBlock missingScopeAction={MissingScopeAction.DISABLE} scope={{ scope: 'integration:update', superScope: ['integration:admin'] }}>
            <Controller
              name='contactCreate.officeId'
              control={form.control}
              render={({ field }) => (
                <SelectDropdown
                  options={officeOptions ?? []}
                  initialSelectedOption={officeOptions?.find((office) => office.id === field.value) ?? null}
                  onOptionSelected={(option) => field.onChange(option.id)}
                  placeholder='Select an office'
                />
              )}
            />
          </ScopedBlock>
        </Col>
      </Row>
      <Row className='mb-1 mt-3'>
        <Col className='d-flex align-items-center'>
          <div>Security groups</div>
        </Col>
        <Col>
          <ScopedBlock missingScopeAction={MissingScopeAction.DISABLE} scope={{ scope: 'integration:update', superScope: ['integration:admin'] }}>
            <Controller
              name='contactCreate.securityGroupId'
              control={form.control}
              render={({ field }) => (
                <SelectDropdown
                  options={securityGroupOptions ?? []}
                  initialSelectedOption={securityGroupOptions?.find((securityGroup) => securityGroup.id === field.value) ?? null}
                  onOptionSelected={(option) => field.onChange(option.id)}
                  placeholder='Select a security group'
                />
              )}
            />
          </ScopedBlock>
        </Col>
      </Row>
      <Row className='mt-3'>
        <Col>
          <div className='d-flex gap-3 justify-content-end mb-4'>
            <Button variant='secondary' onClick={handleReset} disabled={isSaving}>
              Reset
            </Button>
            <ScopedBlock missingScopeAction={MissingScopeAction.DISABLE} scope={{ scope: 'integration:update', superScope: ['integration:admin'] }}>
              <Button variant='primary' onClick={form.handleSubmit(onSubmit)} loading={isSaving}>
                Save
              </Button>
            </ScopedBlock>
          </div>
        </Col>
      </Row>
    </Container>
  )
}
